import Vue from 'vue'
import Router from 'vue-router'

import { API } from './services/api';
import Login from './views/login/login.vue'
import Reset from './views/login/reset.vue'
import ResetPassword from './views/login/resetPassword.vue'
import ActivateAccount from './views/login/activate.vue'
import Applications from './views/applications/applications.vue'
import Application from './views/applications/application/application.vue'
import Users from './views/users/users.vue'
import Lessons from './views/lessons/lessons.vue'
import Pages from './views/lessons/pages/pages.vue'
import Components from './views/lessons/pages/components/components.vue'
import Modules from './views/modules/modules.vue'
import PushNotifications from './views/pushNotifications/pushNotifications.vue'
import Questionnairies from './views/questionnaires/questionnaires.vue'
import Sections from './views/questionnaires/sections/sections.vue'
import Questions from './views/questionnaires/sections/questions/questions.vue'
import Options from './views/questionnaires/sections/questions/options/options.vue'
import Export from './views/export/export.vue'
import Statistics from './views/statistics/statistics.vue'
import Images from './views/storage/images.vue'
import Videos from './views/storage/videos.vue'
import Documents from './views/storage/documents.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter(to, from, next) {
        if (localStorage.authenticated) {
          next('/applications');
        } else {
          next();
        }
      }
    },
    {
      path: '/reset',
      name: 'reset',
      component: Reset
    },
    {
      path: '/reset-password/:id',
      name: 'resetPassword',
      component: ResetPassword
    },
    {
      path: '/activate-account/:id',
      name: 'activateAccount',
      component: ActivateAccount
    },
    {
      path: '/applications',
      name: 'applications',
      component: Applications,
      beforeEnter(to, from, next) {
        API.get(
          'index.cfm?act=accounts.me'
        ).then(
          response => {
            if (response.data.data.isAdmin === true) {
              localStorage.isAdmin = true;
              next();
            } else {
              localStorage.isAdmin = false;
              next('/lessons');
            }
          }
        )

        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/applications/:id',
      name: 'application',
      component: Application,
      beforeEnter(to, from, next) {
        API.get(
          'index.cfm?act=accounts.me'
        ).then(
          response => {
            if (response.data.data.isAdmin === true) {
              localStorage.isAdmin = true;
              next();
            } else {
              localStorage.isAdmin = false;
              next('/lessons');
            }
          }
        )

        if (!localStorage.authenticated) {
          localStorage.isAdmin = true;
          next('/login');
        } else {
          localStorage.isAdmin = false;
          next();
        }
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      beforeEnter(to, from, next) {
        API.get(
          'index.cfm?act=accounts.me'
        ).then(
          response => {
            if (response.data.data.isAdmin === true) {
              localStorage.isAdmin = true;
              next();
            } else {
              localStorage.isAdmin = false;
              next('/lessons');
            }
          }
        )

        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/lessons',
      name: 'lessons',
      component: Lessons,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/lessons/:pageId/pages',
      name: 'pages',
      component: Pages,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/lessons/:pageId/pages/:id/components',
      name: 'components',
      component: Components,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/modules',
      name: 'modules',
      component: Modules,
      children: [
        {
          path: 'faq',
          name: 'faq',
          component: Modules
        },
        {
          path: 'text',
          name: 'text',
          component: Modules
        },
        {
          path: 'tips',
          name: 'tips',
          component: Modules,
          children: [
            {
              path: ':id',
              name: 'tip',
              component: Modules
            },
          ]
        },
        {
          path: 'motivators',
          name: 'motivators',
          component: Modules
        },
        {
          path: 'issues',
          name: 'issues',
          component: Modules
        },
        {
          path: 'moments',
          name: 'moments',
          component: Modules,
          children: [
            {
              path: ':id',
              name: 'momentstrategy',
              component: Modules
            },
          ]
        },
        {
          path: 'situations',
          name: 'situations',
          component: Modules
        },
        {
          path: 'strategy',
          name: 'strategy',
          component: Modules
        }
      ]
    },
    {
      path: '/export',
      name: 'export',
      component: Export,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/push-notifications',
      name: 'pushnotifications',
      component: PushNotifications,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/questionnaires',
      name: 'questionnaires',
      component: Questionnairies,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/questionnaires/sections/:id',
      name: 'sections',
      component: Sections,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/questionnaires/sections/:id/questions/:questionid',
      name: 'questions',
      component: Questions,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/questionnaires/sections/:id/questions/:questionid/options/:optionid',
      name: 'options',
      component: Options,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: Statistics,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/images',
      name: 'images',
      component: Images,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/videos',
      name: 'videos',
      component: Videos,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    {
      path: '/documents',
      name: 'documents',
      component: Documents,
      beforeEnter(to, from, next) {
        if (!localStorage.authenticated) {
          next('/login');
        } else {
          next();
        }
      }
    },
    // {
    //   path: '/storage/0',
    //   redirect: '/storage/1'
    // },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

export default router
